import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import * as AppConstant from '../app.string';
import { UserService } from './user.service';
@Injectable({
  providedIn: 'root'
})
export class HealthRecordsService {

  private repoUrl: string;
  constructor( private http: HttpClient, private user: UserService ) { 
    this.repoUrl = this.user.getRepoUrl();
  }

  public getPrescriptions(uhid: string, visit?: any): Observable<any>{
    console.log("visit", visit)
    let payload = {
      patientId: uhid,
      patientClass: visit ? visit['patientClass'] : null,
      visitId: visit ? visit['encounterId'] : null,
      getERXInfo:"Y"
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/visits/prescriptions`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getPendingBill(data: any): Observable<any>{
    let payload = {
      facilityId: data.facilityid,
      patientId: data.uhid,
      key: data.uhid
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/outpatients/getUnbilledEncounters`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getSettledBill(data: any): Observable<any>{
    let payload = {
      facilityId: data.facilityid,
      patientId: data.uhid,
      pageCount: 1
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/outpatients/getPatientBills`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getBillDetails(facilityid: string, data: any, patient: any): Observable<any>{
    let payload = {
      facilityId: facilityid,
      billNo: data.billNo,
      patientId: patient.uhid || patient['patient_id'],
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/outpatients/getBillDetail`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public generateBillHtml(data: any): Observable<any>{
    // let payload = {
    //   facilityId: facilityid,
    //   billNo: data.billNo
    // }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/outpatients/generateBillHtml`, data).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getErrorMessage(error) {
    if (typeof error === 'string')
      return error;
    if (error && error.error && error.error.error && error.error.error.message)
      return error.error.error.message;
    return 'Something went wrong';
  }

  public getFeedbackData(patientId, encounterId, patientClass): Observable<any> {
    let payload = {
      patientId: patientId,
      encounterId:  encounterId,
      patientClass:  patientClass
    }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/services/getFeedback`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public recordFeedback(payload): Observable<any> {
    // let payload = {
    //   patientId: patientId,
    //   encounterId:  encounterId,
    //   patientClass:  patientClass
    // }
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/services/recordFeedback`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public getBillDetailsOfBillNo(uhid, billNo) {
    let payload = {
      billNo: billNo,
      patientId: uhid,
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/widgets/getDtlsOfBill`, payload).subscribe((data) => {
        let billDetail = this.parseBillDetail(data['data'][0]);
        observer.next(billDetail);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getFinancialBillingSummary(data) {
    let payload = {
      facilityId: data.facilityid,
      patientId: data.uhid,
      billYear: 'ALL'
    }

    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/payments/getFinancialBillingSummary`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public getWidgetBills(billType: 'O' | 'P' | 'A', page, perPage): Observable<any> {
    let payload = {
      pageNo:page,
      recordsPerPage: perPage,
      billStatus: billType,
      personId: this.user.getPersonId(),
      billYear:'ALL'
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/widgets/bills`, payload).subscribe((data) => {
        let bills = this.parseBills(data['data']);
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  public parseBillDetail(bill) {
    if (bill && bill.installementdtls && bill.installementdtls.length > 0) {
      bill.installementdtls = bill.installementdtls.sort((a, b) => {
        return a.installement_no - b.installement_no;
      })
    }
    return bill
  }

  public parseBills(bills) {
    if (bills && bills.settledBills && bills.settledBills.length > 0) {
      bills.settledBills = bills.settledBills.map(b => {
        if (b.installmentDueDetails) {
          let det = b.installmentDueDetails.split('#');
          if (det.length > 0) {
            b.installmentDueObj = {
              date: det[0],
              pay: det[1],
              string: b.installmentDueDetails
            }
          }
        }
        return b
      })
    }
    if (bills && bills.unsettledBills && bills.unsettledBills.length > 0) {
      bills.unsettledBills = bills.unsettledBills.map(b => {
        if (b.installmentDueDetails) {
          let det = b.installmentDueDetails.split('#');
          if (det.length > 0) {
            b.installmentDueObj = {
              date: det[0],
              pay: det[1],
              string: b.installmentDueDetails
            }
          }
        }
        return b
      })
    }
    return bills;
  }

  public getRefunPendingDtls(facilityid: string, patient: any): Observable<any>{
    let payload = {
      facilityId: facilityid,
      patientId: patient['uhid'] || patient['patient_id'],
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/billing/getRefundPendingDtls`, payload).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public generateRecieptHtml(facilityId: string, patientId: string, reciept: any, locale?: string): Observable<any> {
    var tmp;
    if (reciept && reciept.docRef) {
      tmp = reciept.docRef.split('/');
    }
    let payload = {
      facilityId: facilityId,
      patientId: patientId,
      receiptTypeCode: tmp[0],
      receiptDocNum: tmp[1],
      recieptNo: reciept.docRef
    }
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/outpatients/generateReceiptHtml`, payload, { reportProgress: false }).subscribe((response) => {
        if (response['status'] == 'SUCCESS')
          return observer.next(response['data']);
        return observer.error();
      }, error => observer.error(this.getErrorMessage(error)));
    })
  }

  public generatePrescriptionHtml(data: any): Observable<any>{
    return Observable.create(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/outpatients/generatePrescriptionHtml`, data).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
 
  public generateQRCodeForReport(params: any): Observable<any>{
    if (!params['patientId'] && params['patientInfo'] && params['patientInfo']['patient_id']) {
      params['patientId'] = params['patientInfo']['patient_id'];
    }
    const payload = {
      patientId: params['patientId'],
      reportId:params['reportId'],
      facilityId:params['facilityId'],
      repoInfo:params['repoToken'],
    };
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}api/careEvents/createQRCodeForReport`, payload, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }

  public generateEPrescribeUrl(data: any): Observable<any> {
    return Observable.create(observer => {
      this.http.post(`${environment['API_URL']}nahdi/pharmacy/getPharmacyUrl`, data, { reportProgress: true }).subscribe((data) => {
        observer.next(data['data']);
      }, error => {
        observer.error(this.getErrorMessage(error));
      })
    });
  }
  

  public getAllBillsForPatient(patientId): Observable<Array<any>> {
    return new Observable(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/visits/getPatientBillingClaimSummary`, { patientId })
        .subscribe((data) => {
          return observer.next(data['data']);
        });
    })
  }

  public getBillItemDetails(billNo, patientId): Observable<any[]> {
    let payload = {
      patientId: patientId,
      billNo: billNo
    }
    return new Observable(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/visits/getPatientBillingClaimSummary`,payload)
        .subscribe((data) => {
          return observer.next(data?.['data']);
        });
    })
  }

  public getBillItemDetails_MockAPI(billNo, patientId): Observable<any> {
    return new Observable(observer => {
      // this.http.post(`${this.user.getRepoUrl()}api/`, {patientId}).subscribe((data) => {
      const dummyData = [{ "billNo": "CLA2OPBL198", "billStatus": "entered-in-error", "billDate": "2020-10-06T19:16:24+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "CA03", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "34565654545454", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA4OPBL2", "billStatus": "active", "billDate": "2020-10-25T14:03:30+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "DA07.8", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "29292929292929", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLE6OPBL7", "billStatus": "active", "billDate": "2020-10-27T18:40:16+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "1D85.2", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "24354653435343", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "LA", "serviceDisplay": "HDL Cholesterol - Serum", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA1OPBL377", "billStatus": "active", "billDate": "2020-10-06T20:12:12+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "CA03", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "22345678910234", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 50, "coPay": 50, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA1OPBL387", "billStatus": "active", "billDate": "2020-10-07T15:45:56+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "CA20", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "22345678910234", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 50, "coPay": 50, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA2OPBL19244", "billStatus": "active", "billDate": "2020-07-21T14:48:46+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "5A03", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "749854fe-fa0a-46d3-8c6d-f96458c62565", "billStatus": "entered-in-error", "billDate": "2020-07-20T15:51:53+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "1A07", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "d9ab15da-e0ba-420d-96e8-045f0435dcef", "billStatus": "active", "billDate": "2020-07-20T15:51:53+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "1A07", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA2OPBL193", "billStatus": "active", "billDate": "2020-07-21T14:49:54+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "1A07", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA2OPBL184", "billStatus": "active", "billDate": "2020-07-21T14:27:18+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "1A07", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLE6OPBL14", "billStatus": "entered-in-error", "billDate": "2020-11-09T11:35:54+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "CA03", "desc": "", "classification": "primary" }, { "code": "CA01", "desc": "", "classification": "secondary" }], "insuranceDetails": [{ "insuranceNo": "26789878987878", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "RD", "serviceDisplay": "X-ray of paranasal sinuses. One view", "itemQuantity": 1, "net": 90, "coPay": 10, "Discount": 0, "gross": 100 }, { "itemCategory": "RD", "serviceDisplay": "Abdominal ultrasound NOS", "itemQuantity": 1, "net": 90, "coPay": 10, "Discount": 0, "gross": 100 }, { "itemCategory": "LA", "serviceDisplay": "Complete Urine Analysis", "itemQuantity": 1, "net": 90, "coPay": 10, "Discount": 0, "gross": 100 }], "totalBill": 300 }, { "billNo": "CLA2IPBL9", "billStatus": "entered-in-error", "billDate": "2020-10-06T19:50:33+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "CA03", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "86541352413500", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Specialiest", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }, { "itemCategory": "RB", "serviceDisplay": "Room Charges - Regular", "itemQuantity": 1, "net": 200, "coPay": 0, "Discount": 0, "gross": 200 }, { "itemCategory": "CO", "serviceDisplay": "Doctor Charges - Daily visit", "itemQuantity": 1, "net": 150, "coPay": 0, "Discount": 0, "gross": 150 }, { "itemCategory": "CO", "serviceDisplay": "Nursing Charges - Daily visit", "itemQuantity": 1, "net": 50, "coPay": 0, "Discount": 0, "gross": 50 }], "totalBill": 500 }, { "billNo": "CLA1OPBL45001", "billStatus": "entered-in-error", "billDate": "2020-11-10T12:15:25+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "5A10", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "26789878987878", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 70, "coPay": 30, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLE6OPBL10", "billStatus": "active", "billDate": "2020-11-09T11:22:11+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "1D85.2", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "24354653435343", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 100, "coPay": 0, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA1OPBL454", "billStatus": "entered-in-error", "billDate": "2020-11-09T17:19:30+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "5A10", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "26789878987878", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 70, "coPay": 30, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA1OPBL45_2", "billStatus": "active", "billDate": "2020-11-09T12:15:25+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "5A10", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "26789878987878", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 70, "coPay": 30, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA1OPBL42_8", "billStatus": "active", "billDate": "2020-10-27T19:10:28+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "CA20.Z", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "86541352413501", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 50, "coPay": 50, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA4OPBL_6", "billStatus": "active", "billDate": "2020-10-27T18:11:16+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility. (eligibility)", "diagnosis": [{ "code": "CA00", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "29292929292929", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "LA", "serviceDisplay": "CBC", "itemQuantity": 1, "net": 90, "coPay": 10, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA1OPBL45000", "billStatus": "active", "billDate": "2020-11-10T12:11:40+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "5A10", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "26789878987878", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "CO", "serviceDisplay": "Examination by Consultant", "itemQuantity": 1, "net": 50, "coPay": 50, "Discount": 0, "gross": 100 }], "totalBill": 100 }, { "billNo": "CLA1OPBL484", "billStatus": "active", "billDate": "2020-11-15T14:50:00+02:00", "billType": "Doctor, Pathology, Optometry and Hospital Eligibility.  (eligibility)", "diagnosis": [{ "code": "5A10", "desc": "", "classification": "primary" }], "insuranceDetails": [{ "insuranceNo": "26789878987878", "insuranceClaimStatus": "" }, { "insuranceNo": "66666666", "insuranceClaimStatus": "" }], "items": [{ "itemCategory": "PH", "serviceDisplay": "RIFAMPIN 300MG HARD GELATIN CAPSULES", "itemQuantity": 7, "net": 19.6, "coPay": 8.4, "Discount": 0, "gross": 28 }, { "itemCategory": "PH", "serviceDisplay": "AMPICILLIN 500MG LYOPHILIZED POWDER", "itemQuantity": 7, "net": 588, "coPay": 252, "Discount": 0, "gross": 840 }], "totalBill": 868 }];
      let bill = dummyData.find(d => d['billNo'] == billNo);
      return observer.next(bill);
      // });
    })
  }

  public getVisitSummary(data): Observable<any[]> {
    return new Observable(observer => {
      this.http.post(`${this.user.getRepoUrl()}api/visits/clinicalHistory`, data)
        .subscribe((data) => {
          return observer.next(data?.['data']);
        }, error => {
          observer.error(this.getErrorMessage(error));
        })
    })
  }

}


